import React, { useEffect, useRef } from "react";
import Iterator from "../utils/Iterator";
import { IMG_URl } from "../../common/img_url";
import { indexStore } from "../../store/indexStore";
import MenuCircle from "./MenuCircle";
import MenuModel from "../../Models/MenuModel";

type CirclesMenuProps = {
  data: MenuModel[];
  onClickMenu: (id: string) => void;
  selectedMenu?: string;
  displayWaygrid?: boolean;
  IMG_URl?: string;
};

function CirclesMenu(props: CirclesMenuProps) {
  const { name } = indexStore();

  const scrollView = useRef<HTMLDivElement | null>(null);

  const updateArrowVisibility = () => {
    const ref = scrollView.current;
    if (!ref) return;
  };

  useEffect(() => {
    updateArrowVisibility();
    window.addEventListener("resize", updateArrowVisibility);
    return () => window.removeEventListener("resize", updateArrowVisibility);
  }, [props.displayWaygrid]);

  ////////////////////////////////////////////////////////////

  return (
    <div className="flex justify-between items-center gap-3">
      <div
        className={`flex w-full pb-2 gap-3 md:gap-4 overflow-x-auto scroll-smooth scrollbar-hide ${
          props.displayWaygrid
            ? "grid grid-cols-3 xs:grid-cols-3 md:grid-cols-5 gap-3"
            : props.selectedMenu
            ? "px-3 gap-4 md:gap-5"
            : "gap-4 md:gap-5"
        }`}
        ref={scrollView}
      >
        <Iterator
          data={props.data}
          render={(e, i) => (
            <div
              key={e.id || i}
              className="opacity-0 animate-[fadeIn_0.3s_ease-out_forwards] shrink-0"
              style={{
                animationDelay: `${i * 50}ms`,
              }}
            >
              <MenuCircle
                element={e}
                name={name as keyof MenuModel}
                props={props}
                IMG_URl={IMG_URl}
              />
            </div>
          )}
        />
      </div>
    </div>
  );
}

export default CirclesMenu;
